import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { isRequired } from 'components/Questionnaires/validators';

export const QuestionButtonsField = ({ intl, blockId, question, className, onChange, buttons }) => {
  const [inputValue, setInputValue] = useState(question?.answer ?? question.default ?? '');

  const onInputChange = (event) => {
    setInputValue(event.target.value);
    onChange(question, event.target.value);
    return true;
  };

  const getButtonClass = (buttonValue, buttonIndex) => {
    let buttonClass = `btn questionnaire-button ${ (inputValue === buttonValue) ? 'selected' : '' }`;
    if (buttons.length && buttons.length === 2) {
      buttonClass += ' small';
    } else if (buttons.length && buttonIndex % 2 === 0) {
      buttonClass += ' left';
    }

    if (question.isValid === false) {
      buttonClass += ' error';
    }

    return buttonClass;
  };

  useEffect(() => {
    if (inputValue) {
      onChange(question, inputValue);
    }
  }, []);

  useEffect(() => {
    setInputValue(question.answer ?? question.default ?? '');
  }, [question.answer]);

  return (<div
    className={ `button-container ${ className }` }
    id={ `${ blockId }-${ question.id }` }
    role="radiogroup"
    aria-required={ isRequired(question) }
    aria-describedby={ question.isValid === false ? (`${ blockId }-${ question.id }-error`) : undefined }
    aria-labelledby={ `${ blockId }-${ question.id }-lbl` }
  >
    { buttons.map((b, i) => (<button
      key={ `${ blockId }-${ question.id }-${ b.text }` }
      value={ b.value }
      className={ getButtonClass(b.value, i) }
      type="button"
      role="radio"
      aria-checked={ inputValue === b.value }
      onClick={ e => onInputChange(e) }
    >{intl.formatMessage({ id: b.text }) }</button>
    )) }
  </div>);
};

QuestionButtonsField.displayName = 'QuestionButtonsField';

QuestionButtonsField.propTypes = {
  intl: PropTypes.shape().isRequired,
  blockId: PropTypes.string.isRequired,
  question: PropTypes.shape().isRequired,
  className: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, text: PropTypes.string })).isRequired,
  onChange: PropTypes.func.isRequired
};

QuestionButtonsField.defaultProps = {
  className: '',
};

export default QuestionButtonsField;
